import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingBlurTextInImageConfig } from '@/data/landingConfig/landingBlurTextInImageConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_BlurTextInImage } from './schemaObject';

interface Props {}

const BlurTextInImage: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_BlurTextInImage} />
			<LandingTemplate
				data={landingBlurTextInImageConfig}
				funnelLinkService={GenerateLandingLinkService.funnelBlur()}
			/>
		</>
	);
};

export default BlurTextInImage;
